import React from 'react';

export default class Brinde extends React.Component {

    render(){

        return (
          <>


            <section className="page-section portfolio" id="duvidas">
                <div className="container">

                <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">Brinde</h2>

                <div className="divider-custom">
                    <div className="divider-custom-line"></div>
                    <div className="divider-custom-icon">
                    <i className="fa fa-star"></i>
                    </div>
                    <div className="divider-custom-line"></div>
                </div>

                <div className="row">
                        <div className="col-md-6">
                        <video width="100%" height="auto" controls>
                        <source src={process.env.PUBLIC_URL+"/video/brinde.mp4"} type="video/mp4" />
                        Your browser does not support the video tag.
                        </video>
                      </div> 

                        <div className="col-md-6">
                          <h2>Ao adquirir nossa loja, você ganha um vídeo de um de seus produtos ou servíços similar ao mostrado ao lado.</h2>
                          <p>Esse vídeo pode ser usado para fazer propaganda da sua loja virtual pelo facebook, facebooks ads e google ads.</p>
                          <p>Veja as características do vídeo:</p>
                          <ul className="ml-3">
                            <li>Vídeo rápido, menos de 1 minuto, ideal para o instagram;</li>
                            <li>A logomarca da sua empresa aparece no final do vídeo;</li>
                            <li>Você pode escolher o produto que deseja usar;</li>
                            <li>O Vídeo tem música de fundo e voz explicando sobre o produto;</li>
                            <li>Resolução do vídeo: 1080x1080 (padrão do instagram) Alta resolução.</li>
                            <li>Alta compactação: de 5 a 25 mega.</li>
                          </ul>
                          <hr/>
                          <h3>Obs: Caso você queira mais vídeos de outros produtos, basta entrar em contato conosco.</h3>
                        </div> 
                </div>

                </div>
            </section>

          </>
        );
      }

}